/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'jianshi': {
    width: 13,
    height: 12,
    viewBox: '0 0 13 12',
    data: '<path pid="0" d="M12.155 0H.847A.845.845 0 000 .845v8.329c0 .468.38.847.847.847h11.308A.845.845 0 0013 9.174V.845A.845.845 0 0012.155 0zm0 8.728a.424.424 0 01-.424.421H1.278a.424.424 0 01-.424-.421v-7.46c0-.233.19-.423.424-.423H11.73a.424.424 0 01.424.424v7.459zm-1.32-2.282H8.72a.412.412 0 01-.271-.11L6.5 4.333a.448.448 0 00-.65.053L4.442 6.23a.473.473 0 01-.325.163H2.174a.466.466 0 01-.448-.437.426.426 0 01.448-.43h1.518a.383.383 0 00.325-.164l1.725-2.275a.448.448 0 01.65-.053l2.383 2.384c.075.067.17.106.271.108h1.793c.23.018.411.2.428.43a.48.48 0 01-.432.489v.002zm-9.21 4.55h9.696c.233.015.419.2.435.433a.428.428 0 01-.435.432H1.625a.433.433 0 110-.865z" _fill="#EC102D" fill-rule="nonzero"/>'
  }
})
